import React from "react";

import { formatNumber } from "utils";

import { AdminDescriptions, Anchor, Col, Link, Row } from "components";

export const FarmDetailsTab = ({ farm }) =>
  farm && (
    <>
      <Row>
        <Col>
          <AdminDescriptions
            items={[
              {
                label: "User",
                span: 1,
                children: farm.user ? <Link to={`/user/${farm.user.id}`}>{farm.user.name}</Link> : "Unknown",
              },
              {
                label: "Farm code",
                span: 1,
                children: farm.code,
              },
              {
                label: "Creation date",
                span: 1,
                children: farm.date,
              },
              {
                label: "Address",
                span: 3,
                children:
                  farm.addressStreet !== "-" ? (
                    <>
                      {farm.addressStreet} {farm.addressNumber}, {farm.addressCity}
                    </>
                  ) : (
                    <>-</>
                  ),
              },
              {
                label: "Region",
                span: 1.5,
                children: farm.region ? farm.region : "-",
              },
              {
                label: "Zip",
                span: 1.5,
                children: farm.zip ? farm.zip : "-",
              },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <AdminDescriptions
            items={[
              {
                label: "Shapefile",
                span: 1,
                children: farm.shapefile ? (
                  <Anchor target="_blank" href={farm.shapefile}>
                    View shapefile
                  </Anchor>
                ) : (
                  "-"
                ),
              },
              {
                label: "Pipedrive deal",
                span: 1,
                children: farm.dealId ? (
                  <Anchor target="_blank" href={`https://klim2.pipedrive.com/deal/${farm.dealId}`}>
                    {farm.dealId}
                  </Anchor>
                ) : (
                  "-"
                ),
              },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <AdminDescriptions
            items={[
              {
                label: "Fields",
                span: 1,
                children: farm.fields ? farm.fields : "-",
              },
              {
                label: "Farm size (ha)",
                span: 1,
                children: farm.size ? farm.size : "-",
              },
              {
                label: "Max hectares",
                span: 1,
                children: farm.maxHectares ? farm.maxHectares : "-",
              },
              {
                label: "Leased land share",
                span: 1,
                children: farm.land ? farm.land : "-",
              },
              {
                label: "Certifications",
                span: 1,
                children:
                  farm.certifications &&
                  farm.certifications.length > 0 &&
                  farm.certifications.map((item, i) => {
                    if (farm.certifications.length > i + 1) {
                      return <span key={i}>{item} | </span>;
                    }
                    return <span key={i}>{item}</span>;
                  }),
              },
            ]}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <AdminDescriptions
            items={[
              {
                label: "Applied modules",
                span: 1,
                children: (
                  <>
                    {formatNumber({ number: farm.areaWithModules, decimalPlaces: 4 })} ha (
                    {formatNumber({
                      number: (farm.areaWithModules / parseFloat(farm.size)) * 100,
                      decimalPlaces: 2,
                    })}
                    %)
                  </>
                ),
              },
              {
                label: "Module types",
                span: 2,
                children: (
                  <>
                    <span>Crop rotations: {farm.farmTotalModules["Crop rotations"] ? farm.farmTotalModules["Crop rotations"] : 0}</span>
                    <br />
                    <span>Fertilizers: {farm.farmTotalModules.Fertilizer ? farm.farmTotalModules.Fertilizer : 0}</span>
                    <br />
                    <span>Pesticides: {farm.farmTotalModules.Pesticides ? farm.farmTotalModules.Pesticides : 0}</span>
                    <br />
                    <span>Tillage &amp; Seeding: {farm.farmTotalModules["Tillage & Seeding"] ? farm.farmTotalModules["Tillage & Seeding"] : 0}</span>
                  </>
                ),
              },
            ]}
          />
        </Col>
      </Row>
    </>
  );
